import { Dropdown } from 'primereact/dropdown'
import styled from 'styled-components'

export const DropdownWrapper = styled.div`
  position: relative;
`

export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  min-width: 15rem;
  height: 40px;
  border-radius: 10px;
  align-items: center;
  margin-bottom: 1rem;
  border: none !important;

  .p-dropdown-panel {
    z-index: 1004 !important;
    position: absolute !important;
    left: 0px !important;
    top: 44px !important;
    min-width: 100% !important;
    min-height: 100% !important;
    background: #ffffff !important;
    transform-origin: center top !important;
  }

  @media (max-width: 1200px) {
    width: 12rem;
  }
`
